var modalInit;

(function($){
		
	const selectors = {
		modal: '[data-modal]',
		close: '[data-modal-close]'
	}
	
	modalInit = function(){
		$(selectors.modal).each((i, el) => {
			new Modal(el);
		});
	}
	
	class Modal {
		constructor(element){
			this.$modal = $(element);
			
			this.init();
			this.bind();
			
			
		}
		init(){
			this.$triggers = $('a[href="#'+this.$modal.attr('id')+'"]');
			this.$close_btns = $(selectors.close, this.$modal);
		}
		bind(){
			this.$modal.click( (e) => { e.preventDefault(); this.hide(); });
			this.$modal.find('.o-modal__inner').click( (e) => { e.stopPropagation(); });
			this.$triggers.click( (e) => { e.preventDefault(); this.show(); })
			this.$close_btns.click( (e) => { e.preventDefault(); this.hide(); })
		}
		
		
		
		show(){
			this.$modal.stop().fadeIn();
			$(document.body).addClass('is-modal-open');
		}
		hide(){
			this.$modal.stop().fadeOut();
			$(document.body).removeClass('is-modal-open');
		}
		
	}
})(jQuery);
	
export default modalInit;